'use strict';

var _ = require('lodash');
var $ = require('jquery');
var DayOfWeekDirective = function DayOfWeekDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/day-of-week.html'),
    controller: 'DayOfWeekController',
    require: 'ngModel',
    scope: {
      // [true,false*]
      isDisabled: '=?',
      disabledDays: '=',
      daysFullNames: '=?'
    },
    link: function link($scope, elem, attr, ngModelCtrl) {
      var initialized = false;
      $scope.isDisabled = $scope.isDisabled || false;
      function updateDistabledItems() {
        var allDays = $scope.dowArray[0];
        if ($scope.disabledDays && $scope.disabledDays.length > 0) {
          _.forEach($scope.dowArray, function (dow) {
            dow.disabled = $scope.disabledDays.indexOf(dow.id) !== -1;
          });
          allDays.disabled = true;
        } else {
          allDays.disabled = false;
        }
      }
      function areAllButtonsActive() {
        var selectedValues = ngModelCtrl.$viewValue;
        return selectedValues && selectedValues.length === $scope.allDowArray.length;
      }
      function isBtnActive(btnId) {
        var selectedValues = ngModelCtrl.$viewValue;
        return !!(selectedValues && selectedValues.indexOf(btnId) !== -1);
      }
      function updateActiveClass() {
        var allButtonsActive = areAllButtonsActive();
        elem.find('.dow-button').each(function (i, btn) {
          var $btn = $(btn);
          var val = $btn.find('input').val();
          $btn.toggleClass('active', allButtonsActive || isBtnActive(val));
        });
      }
      function toggleItem(collection, item, condition) {
        if (condition) {
          _.pull(collection, item);
        } else {
          collection.push(item);
        }
      }
      function adjustActiveButtons(itemId) {
        var allBtnActive = areAllButtonsActive();
        var currentViewValue = ngModelCtrl.$viewValue;
        if (itemId === 'all') {
          currentViewValue = allBtnActive ? null : $scope.getAllDays();
        } else {
          currentViewValue = currentViewValue || [];
          toggleItem(currentViewValue, itemId, isBtnActive(itemId));
          currentViewValue = _.isEmpty(currentViewValue) ? null : currentViewValue;
        }
        ngModelCtrl.$setViewValue(currentViewValue);
      }
      elem.on('click', '.btn', function () {
        var itemId = $(this).find('input').val();
        elem.triggerHandler('focus');
        $scope.$apply(function () {
          adjustActiveButtons(itemId);
        });
        return false;
      });
      ngModelCtrl.$render = function () {
        // set all by default
        if (!initialized && !ngModelCtrl.$viewValue) {
          ngModelCtrl.$setViewValue($scope.getAllDays());
        }
        initialized = true;
      };
      $scope.$watch('disabledDays', function () {
        updateDistabledItems();
      });
      $scope.$watch(function () {
        updateActiveClass();
      });
    }
  };
};
DayOfWeekDirective.$inject = [];
module.exports = DayOfWeekDirective;